import React from "react"

//Components
import { Modal, Button, Image, Input, DatePicker, Check } from "components/anti"
import { ModalBs } from "./anti/modal/modal-bootstrap"

//Assets
import StockImg from "@public/img/sample/stock.png"
import DocumentImg from "@public/img/sample/document.png"
import ModalAuthImg from "@public/img/sample/modal-auth.png"

//Utils
import { useRouter } from "next/router"
import { F_M_LOGIN, F_M_REGISTER, sendDatalayerProduct } from "lib/function"
import Cookies from "js-cookie"
import * as Yup from "yup"
import { Formik } from "formik"

const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/

// ===================================== STOCK ADJUSMENT =========================================== //
export const ModalStockAdjustment = ({ id, show, hide, callback }) => {
  //utils
  const Router = useRouter()
  const locale = Router.locale

  //Functions
  const handleClick = () => {
    Router.push("/carts")
    if (callback) callback()
  }

  return (
    <Modal
      id={id}
      isShowing={show}
      hide={hide}
      className="modal-sm"
      contentClassName="bg-gray"
    >
      <div>
        <div className="py-2 d-flex justify-content-center align-items-center">
          <div className="stock-blank-wrapper p-3 d-flex justify-content-center align-items-center">
            <Image src={StockImg} className="stock-blank-icon" />
          </div>
        </div>
        <h3 className="text-center">Stock Adjustment</h3>
        <p className="text-center">
          Our product availability have changed. Please review your order before
          proceeding.
        </p>
        <div className="mt-4 pt-3">
          <Button className="w-100" onClick={handleClick}>
            PROCEED TO MY CART
          </Button>
        </div>
      </div>
    </Modal>
  )
}
// ===================================== STOCK ADJUSMENT =========================================== //

// ===================================== LOGIN ==============================++++================== //

export const ModalLogin = ({ id, show, hide, callback, checkout }) => {
  const Router = useRouter()
  const locale = Router.locale

  const YupLoginValidation = Yup.object({
    email: Yup.string()
      .email(
        locale === "id" ? "Format email tidak valid" : "Invalid email format"
      )
      .required(locale === "id" ? "Email harus diisi" : "Email required"),
    password: Yup.string()
      .required(
        locale === "id" ? "Kata sandi harus diisi" : "Password required"
      )
      .matches(
        passwordRegex,
        locale === "id"
          ? "Password harus memiliki minimal 8 karakter dan minimal 1 angka"
          : "Password must have a minimum of 8 characters and at least 1 number"
      ),
  })
  //States

  const initialState = {
    email: "",
    password: "",
  }

  const [state, setState] = React.useState({
    loading: null,
    isError: null,
  })

  //Functions
  const handleLogin = async (values) => {
    let token = Cookies.get(`${process.env.GUEST_TOKEN}`)
    if (token) {
      setState((prev) => ({ ...prev, loading: true }))
      try {
        let { data, errors } = await F_M_LOGIN({
          username: values.email,
          password: values.password,
        })
        if (data) {
          let { access_token, refresh_token } = data?.login
          if (access_token) {
            Cookies.set(`${process.env.ACCESS_TOKEN}`, access_token, {
              expires: 14,
              secure: true,
              domain: process.env.BASE_DOMAIN,
            })
            if (checkout) {
              window.location.href = "/checkout"
            } else {
              window.location.reload()
            }
          } else {
            setState((prev) => ({ ...prev, loading: false }))
          }
        } else {
          //!NEED ERROR HANDLING
          setState((prev) => ({ ...prev, loading: false, isError: true }))
        }
      } catch (error) {
        //!NEED ERROR HANDLING
        setState((prev) => ({ ...prev, loading: false, isError: true }))
      }
    } else {
      alert("NO TOKEN")
    }
  }

  return (
    // <Modal
    //   className="modal-md"
    //   id={id}
    //   isShowing={show}
    //   hide={() => {
    //     hide()
    //     setState((prev) => ({ ...prev, isError: false }))
    //   }}
    //   contentClassName="p-0 m-0"
    // >
    <ModalBs
      className="modal-md"
      id={id}
      isShowing={show}
      hide={() => {
        hide()
        setState((prev) => ({ ...prev, isError: false }))
      }}
      contentClassName="p-0 m-0"
    >
      <div onClick={hide} className="close">
        <i className="ail ai-times" />
      </div>
      <div className="modal-auth">
        <div className="img-wrapper">
          <h2 className="title-modal">NAGAREY.COM</h2>
          <Image src={ModalAuthImg} className="img-fluid" />
        </div>
        <div className="p-4">
          <h3>{locale === "id" ? "Masuk" : "Sign In"}</h3>
          <p className="sub-text">
            {locale === "id"
              ? "Hanya untuk pengalaman belanja Anda yang lebih cepat dan mudah."
              : "Simply for your faster and easier shopping experience."}
          </p>
          <Formik
            initialValues={initialState}
            validationSchema={YupLoginValidation}
            onSubmit={handleLogin}
          >
            {({
              handleSubmit,
              handleChange,
              touched,
              errors,
              values,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <div className="form-row row-2">
                  <div className="form-group col-12">
                    <Input
                      type="email"
                      name="email"
                      label="EMAIL"
                      placeholder={
                        locale === "id"
                          ? "Masukkan email Anda"
                          : "Insert your email"
                      }
                      onChange={handleChange}
                      errors={errors}
                      touched={touched}
                      value={values.email}
                    />
                  </div>
                  <div className="form-group col-12">
                    <Input
                      name="password"
                      label="PASSWORD"
                      placeholder={
                        locale === "id"
                          ? "Masukkan kata sandi Anda"
                          : "Insert your password"
                      }
                      type="password"
                      onChange={handleChange}
                      errors={errors}
                      touched={touched}
                      value={values.password}
                    />
                    {state.isError && (
                      <p className="error-text mt-2 mb-0 p-0">
                        {locale === "id"
                          ? "Kata sandi / email tidak valid"
                          : "Invalid password / email"}
                      </p>
                    )}
                  </div>
                </div>
                <p
                  className="forgot-text text-right py-1"
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                >
                  {locale === "id"
                    ? "Tidak ingat kata sandi"
                    : "Forgot Password"}
                </p>

                <div className="btn-submit-wrapper">
                  <Button
                    // onClick={handleLogin}
                    type={"submit"}
                    loader
                    className={`${state.loading ? "loading" : ""} w-100`}
                    variant="primary"
                  >
                    {locale === "id" ? "MASUK" : "SIGN IN"}
                  </Button>
                </div>

                <div className="register-new-customer mt-4">
                  <p className="text-center">
                    {locale === "id" ? "Pelanggan baru?" : "New Customer?"}{" "}
                    <b
                      onClick={() => callback()}
                      className=""
                      style={{ fontWeight: "bold", cursor: "pointer" }}
                    >
                      {locale === "id" ? "Klik disini" : "Click Here"}
                    </b>
                  </p>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </ModalBs>
    // </Modal>
  )
}
// ===================================== LOGIN ==============================++++================== //

// ===================================== REGISTER ================================================ //

/**
 * @param {*} param0
 * @returns
 */
export const ModalRegister = ({ id, show, hide, callback }) => {
  //States
  const Router = useRouter()
  const locale = Router.locale

  const YupRegisterValidation = Yup.object({
    email: Yup.string()
      .email(
        locale === "id" ? "Format email tidak valid" : "Invalid email format"
      )
      .required(locale === "id" ? "Email harus diisi" : "Email required"),
    first_name: Yup.string()
      .required(
        locale === "id" ? "Nama Awal harus diisi" : "First name required"
      )
      .test("len", "Minimal 3 character alphabet", (val) => val?.length >= 3)
      .matches(
        /^[a-zA-Z\s]*$/,
        "Invalid Characters. Please use only alphabets to fill your name"
      ),
    last_name: Yup.string()
      .required(
        locale === "id" ? "Nama Akhir harus diisi" : "Last name required"
      )
      .test("len", "Minimal 3 character alphabet", (val) => val?.length >= 3)
      .matches(
        /^[a-zA-Z\s]*$/,
        "Invalid Characters. Please use only alphabets to fill your name"
      ),
    password: Yup.string()
      .required(
        locale === "id" ? "Kata sandi harus diisi" : "Password required"
      )
      .matches(
        passwordRegex,
        locale === "id"
          ? "Password harus memiliki minimal 8 karakter dan minimal 1 angka"
          : "Password must have a minimum of 8 characters and at least 1 number"
      ),
    password_confirmation: Yup.string()
      .required(
        locale === "id" ? "Kata sandi tidak cocok" : "Password does not match"
      )
      .oneOf(
        [Yup.ref("password"), null],
        locale === "id" ? "kata sandi harus cocok" : "Passwords must match"
      ),
    date: Yup.date().required(
      locale === "id" ? "Tanggal lahir harus diisi" : "Date of birth required"
    ),
  })

  const initialState = {
    date: "",
    email: "",
    first_name: "",
    last_name: "",
    password: "",
    password_confirmation: "",
  }

  const [state, setState] = React.useState({
    isLoading: false,
  })

  //Functions
  const handleChangeDate = (e) => {
    return `${new Date(e).getFullYear()}-${
      new Date(e).getMonth() + 1
    }-${new Date(e).getDate()}`
  }

  const handleSubmit = async (values) => {
    setState((prev) => ({ ...prev, isLoading: true }))
    let stringData = handleChangeDate(values.date)
    let name = `${values.first_name} ${values.last_name}`
    let { email, password, password_confirmation } = values
    let { data, errors } = await F_M_REGISTER({
      email,
      name,
      password,
      password_confirmation,
      dob: stringData,
    })

    if (data) {
      window.location.reload()
      if (callback) callback()
    } else {
      setState((prev) => ({ ...prev, isLoading: false }))
    }
  }

  return (
    // <Modal
    //   className="modal-md"
    //   id={id}
    //   isShowing={show}
    //   hide={hide}
    //   contentClassName="p-0 m-0 scrolled"
    // >
    <ModalBs
      className="modal-md"
      id={id}
      isShowing={show}
      hide={hide}
      contentClassName="p-0 m-0 scrolled"
    >
      <div className="modal-auth">
        <div className="img-wrapper">
          <h2 className="title-modal">NAGAREY.COM</h2>
          <Image src={ModalAuthImg} className="img-fluid" />
        </div>
        <div className="p-4">
          <h3>{locale === "id" ? "Pelanggan baru" : "New Customer"}</h3>
          <p className="sub-text">
            {locale === "id"
              ? "Jika Anda pelanggan baru, silakan mendaftar menggunakan formulir di bawah ini untuk checkout lebih cepat."
              : "If you're a new customer, please sign up using the form below for faster checkout."}
          </p>

          <Formik
            initialValues={initialState}
            validationSchema={YupRegisterValidation}
            onSubmit={handleSubmit}
          >
            {({
              handleSubmit,
              handleChange,
              touched,
              errors,
              values,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <div className="form-row row-2">
                  <div className="form-group col-12">
                    <Input
                      type="email"
                      name="email"
                      label="EMAIL"
                      placeholder={
                        locale === "id"
                          ? "Masukkan email Anda"
                          : "Insert your email"
                      }
                      onChange={handleChange}
                      errors={errors}
                      touched={touched}
                      value={values.email}
                    />
                  </div>
                  <div className="form-group col-6">
                    <Input
                      name="first_name"
                      label={locale === "id" ? "NAMA DEPAN" : "FIRST NAME"}
                      placeholder={
                        locale === "id"
                          ? "Masukkan nama depan Anda"
                          : "Insert your first name"
                      }
                      onChange={handleChange}
                      errors={errors}
                      touched={touched}
                      value={values.first_name}
                    />
                  </div>
                  <div className="form-group col-6">
                    <Input
                      name="last_name"
                      label={locale === "id" ? "NAMA KELUARGA" : "LAST NAME"}
                      placeholder={
                        locale === "id"
                          ? "Masukkan nama belakang Anda"
                          : "Insert your last name"
                      }
                      onChange={handleChange}
                      errors={errors}
                      touched={touched}
                      value={values.last_name}
                    />
                  </div>
                  <div className="fomr-group col-12">
                    <div className="field">
                      <div>
                        <DatePicker
                          name="date"
                          wrapperClassName="w-100"
                          placeholder="DD/MM/YYYY"
                          onChange={(e) => setFieldValue("date", e)}
                          selected={values.date}
                          errors={errors}
                          touched={touched}
                          label={
                            locale === "id" ? "TANGGAL LAHIR" : "DATE OF BIRTH"
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group col-12 mt-3">
                    <Input
                      name="password"
                      label="PASSWORD"
                      placeholder={
                        locale === "id"
                          ? "Masukkan kata sandi Anda"
                          : "Insert your password"
                      }
                      type="password"
                      onChange={handleChange}
                      errors={errors}
                      touched={touched}
                      value={values.password}
                    />
                  </div>
                  <div className="form-group col-12">
                    <Input
                      name="password_confirmation"
                      label={
                        locale === "id"
                          ? "KONFIRMASI SANDI"
                          : "CONFIRM PASSWORD"
                      }
                      placeholder={
                        locale === "id"
                          ? "Konfirmasi password Anda"
                          : "Confirm your password"
                      }
                      onChange={handleChange}
                      errors={errors}
                      touched={touched}
                      value={values.password_confirmation}
                      type="password"
                    />
                  </div>
                </div>

                <div className="btn-submit-wrapper mt-4">
                  <Button
                    loader
                    className={`w-100 ${state.isLoading && "loading"}`}
                    type="submit"
                    variant="primary"
                    // onClick={handleSubmit}
                  >
                    {locale === "id" ? "BUAT AKUN" : "CREATE ACCOUNT"}
                  </Button>
                </div>

                <div className="register-new-customer mt-4">
                  <p className="text-center">
                    {locale === "id" ? "Punya akun?" : "Have an account?"}{" "}
                    <b
                      className=""
                      onClick={() => callback()}
                      style={{ fontWeight: "bold", cursor: "pointer" }}
                    >
                      {locale === "id" ? "Klik disini" : "Click Here"}
                    </b>
                  </p>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </ModalBs>
    // </Modal>
  )
}
// ===================================== REGISTER ================================================ //

// ===================================== GUEST CHECKOUT =========================================== //
export const ModalCheckoutContinue = ({ id, show, hide, callback, carts }) => {
  const Router = useRouter()

  const [email, setEmail] = React.useState(null)

  const [btnLoading, setBtnLoading] = React.useState(false)

  const handleSetGuestEmail = (e) => {
    e.preventDefault()
    setBtnLoading(true)
    sendDatalayerProduct({
      event: "begin_checkout",
      data: { ...carts },
      type: 3,
    })
    Cookies.set("guest", email, {
      secure: true,
      domain: process.env.BASE_DOMAIN,
    })
    window.location.href = `${
      Router.locale === "en" ? "/checkout" : "/id/checkout"
    }`
    // Router.push("/checkout");
  }

  return (
    <Modal
      className="modal-md"
      id={id}
      isShowing={show}
      hide={hide}
      contentClassName="p-0 m-0"
    >
      <div className="modal-auth">
        <div className="img-wrapper">
          <h2 className="title-modal">NAGAREY.COM</h2>
          <Image src={ModalAuthImg} className="img-fluid" />
        </div>
        <div className="p-4">
          <h3>Continue check-out</h3>
          <p className="sub-text">
            Sign in or continue as guest to check out your bag
          </p>
          <div>
            {/* <div className="form-row row-2">
              <div className="form-group col-12">
                <Input
                  label="EMAIL"
                  placeholder="Insert your email"
                  onChange={e => setEmail(e.target.value)}
                  // onChange={e => handleChange(e, "username")}
                  type="text"
                />
              </div>
            </div> */}
            <div className="py-3">
              <Button
                onClick={callback}
                className="w-100 border-btn"
                variant="transparent"
              >
                SIGN IN
              </Button>
            </div>
          </div>

          <p className="between-line-text my-4">
            <span className="px-4">OR</span>
          </p>

          <div className="py-3">
            <Button
              className={`w-100 ${btnLoading ? "loading" : ""}`}
              variant="primary"
              loader
              onClick={handleSetGuestEmail}
            >
              CHECKOUT AS GUEST
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
// ===================================== GUEST CHECKOUT =========================================== //
